import ScrollReveal from "../../../components/feature/ScrollReveal";
import { scenesData } from "../../../mocks/homeData";

export default function ScenesSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-navy text-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-14">
              <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
                {scenesData.label}
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold leading-tight">
                {scenesData.title}
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {scenesData.items.map((item, idx) => (
              <ScrollReveal key={item.title} direction="up" delay={idx * 100}>
                <div className="group relative overflow-hidden rounded-lg bg-airdoa-navy-light">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-airdoa-navy/90 via-airdoa-navy/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-[10px] font-medium tracking-ultra text-airdoa-gold uppercase mb-2">
                      {item.tag}
                    </p>
                    <h3 className="text-xl font-serif font-semibold">{item.title}</h3>
                    <p className="mt-2 text-sm text-white/70 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}